import { Subject } from "rxjs";

export class StepDetector {
    GRAVITY = 9.80665;
    stepCount = 0;
    isTheLastStep = false;
    sensibility = 1 / 25;
    isOverThresHoldSensibility = 0.011;
    length = 10;
    norms = null;
    stepIncreaseSub: Subject<any> = null;

    constructor(config) {
        this.initConfig(config);
        this.clear();
    }

    initConfig(sub) {
        this.stepIncreaseSub = sub;
    }

    clear() {
        this.stepCount = 0;
        this.norms = new Array(this.length);
        for (var i = 0; i < this.length; ++i)
            this.norms[i] = this.GRAVITY;
    }

    calcNewSensibility() {
        let root_mean_square = Math.sqrt(this.norms.reduce(function (s, x) { return s + x * x }, 0) / this.length);
        this.sensibility = 3.5 * root_mean_square / this.GRAVITY;
    }

    isSensibility(diff) {
        return diff > this.sensibility;
    }

    updateNorms(R) {
        this.norms.push(R);
        this.norms.shift();
    }

    isOverThresHold(thresHold) {
        let a = this.norms[this.length - 1],
            b = this.norms[this.length - 2],
            c = this.norms[this.length - 3],
            A = Math.abs(a / thresHold / 100);
        return a > thresHold && (b < thresHold || c < thresHold) && A > this.isOverThresHoldSensibility;
    }

    isAStep(x, y, z) {
        let R = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2) + Math.pow(z, 2)), max, min, diff, thresHold;

        this.updateNorms(R);
        max = Math.max.apply(null, this.norms);
        min = Math.min.apply(null, this.norms);
        diff = max - min;
        thresHold = (max + min) / 2;
        this.calcNewSensibility();

        if (this.isSensibility(diff) && !this.isTheLastStep && this.isOverThresHold(thresHold)) {
            this.stepIncreaseSub.next();
            ++this.stepCount;
            this.isTheLastStep = true;
        } else
            this.isTheLastStep = false;
        return this.isTheLastStep;
    }

    increaseStep(number) {
        this.stepCount += number;
        this.stepIncreaseSub.next();
    }



}




// WEBPACK FOOTER //
// /src/tracker/step-detector.ts